import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as MotoristaHttp from '../../../../services/api/https/registration/motorista.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { DateTime } from 'luxon'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'Adquirindo informações dos motoristas',
}

const INITIAL_STATE = {
  motoristas: [],
  modal: {
    show: false,
    data: null,
  },
  motorista: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useMotorista() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getMotoristas(selectedTp) {
        if (selectedTp === 0)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          MotoristaHttp.getMotoristas(selectedTp)
            .then(motoristas => {
              setState(prevState => ({
                ...prevState,
                motoristas: motoristas,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onInit(selectedTp) {
        setState(prevState => ({
          ...prevState,
          selectedTp: selectedTp,
          loadingMessage: LOAD_MESSAGE.INITIAL_GET,
        }))
      },
      onBtnNovo() {
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },
      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },
      onModalSave(motorista) {
        setState(prevState => {
          prevState.modal = { show: false, data: null }
          const index = prevState.motoristas.findIndex(
            motoristaAux => motoristaAux.id === motorista.id,
          )
          if (index !== -1) prevState.motoristas[index] = motorista
          else prevState.motoristas.unshift(motorista)
          prevState.loadingMessage = LOAD_MESSAGE.NONE
          return { ...prevState }
        })
      },
      onDataTableItemClicked(motorista) {
        setState(prevState => ({
          ...prevState,
          modal: {
            show: true,
            data: {
              ...motorista,
            },
          },
        }))
      },
      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
      onBtnExportarExcelClick(motoristas) {
        const colunas = [
          [
            'nome (string)*',
            'numero_cnh (int)',
            'tipo_cnh (string)',
            'data_expiracao_cnh (dd/mm/yyyy)',
            'telefone_contato (int)',
            'endereco (string)',
            'data_expiracao_toxocologico (dd/mm/yyyy)',
            'ativo (0,1)*',
            'cpf (int)',
          ],
        ]

        motoristas.forEach(e => {
          colunas.push([
            e.name,
            e.cnh_number,
            e.cnh_type,
            e.cnh_expiration ? DateTime.fromISO(e.cnh_expiration).toFormat('dd/MM/yyyy') : '',
            e.phone,
            e.address,
            e.toxicologico_expiration
              ? DateTime.fromISO(e.toxicologico_expiration).toFormat('dd/MM/yyyy')
              : '',
            e.actived ? 1 : 0,
            e.cpf,
          ])
        })

        gerarArquivoExcel('Motoristas', colunas, 'motoristas.xlsx')
      },
    }
  }, [])

  return { state, localDispatch }
}
